webpackJsonp([153935816800649],{

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-bottom: 160px;\n  '], ['\n    margin-bottom: 160px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0 0 60px;\n  '], ['\n    padding: 0 0 60px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  '], ['\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      border: 10px solid ', ';\n    '], ['\n      border: 10px solid ', ';\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      font-size: 36px;\n      line-height: 43px;\n    '], ['\n      font-size: 36px;\n      line-height: 43px;\n    ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n      margin-bottom: ', ';\n    '], ['\n      margin-bottom: ', ';\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n      margin: 0 0 ', ';\n      font-size: 64px;\n      line-height: 64px;\n    '], ['\n      margin: 0 0 ', ';\n      font-size: 64px;\n      line-height: 64px;\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0;\n  '], ['\n    padding: 100px 0;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n      font-size: 24px;\n      line-height: 32px;\n      margin-bottom: ', ';\n    '], ['\n      font-size: 24px;\n      line-height: 32px;\n      margin-bottom: ', ';\n    ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMarkdown = __webpack_require__(132);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _shared = __webpack_require__(7);
	
	var _components = __webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__Wrapper'
	})(['background-color:', ';margin-bottom:100px;', ';'], colors.white, _styles.media.laptop(_templateObject));
	
	var FeatureImages = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__FeatureImages'
	})(['padding:0 0 40px;', ';'], _styles.media.tablet(_templateObject2));
	
	var FeatureImagesWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__FeatureImagesWrapper'
	})(['display:flex;']);
	
	var FeatureImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__FeatureImage'
	})(['position:relative;align-self:flex-start;', ';&:nth-child(1){margin-top:15%;}&:nth-child(2){}&:nth-child(3){margin-top:30%;left:-12%;}img{display:block;width:136%;max-width:136%;border:5px solid ', ';', ';}'], _styles.media.tablet(_templateObject3), colors.white, _styles.media.tablet(_templateObject4, colors.white));
	
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__Content'
	})(['font-size:20px;font-weight:400;margin:0 auto;h2{margin-bottom:', ';font-size:30px;line-height:36px;', ';}p,ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';', ';}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}a{transition:all 0.3s;text-decoration:none;color:', ';}a:hover{color:', ';}blockquote{margin:', ' 0 100px;border-left:', ' solid ', ';p{margin:0;padding-left:80px;width:100%;padding-right:100px;font-size:24px;line-height:36px;font-style:italic;font-weight:500;color:', ';}}.embed-container{margin-bottom:', ';}pre{margin:0 0 ', ';font-size:44px;line-height:44px;font-weight:700;color:', ';white-space:normal;text-align:center;', ';}code{font-family:\'sofia-pro\',\'Helvetica Neue\',Helvetica,sans-serif;}img{display:block;max-width:100%;margin:0 auto ', ';}'], sp.m, _styles.media.tablet(_templateObject5), sp.xl, _styles.media.tablet(_templateObject6, sp.xxl), sp.s, colors.blue, sp.s, colors.blue, colors.blue, colors.blue, sp.max, sp.xxs, colors.blue, colors.grey, sp.xxl, sp.xl, colors.royal, _styles.media.tablet(_templateObject7, sp.xl), sp.xxl);
	
	var WorkMeta = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__WorkMeta'
	})(['background-color:', ';margin-bottom:', ';padding:100px 0 60px;', ';h4{font-size:16px;line-height:24px;margin-bottom:', ';', ';span{color:', ';}}'], colors.lightBlue, sp.xxl, _styles.media.tablet(_templateObject8), sp.s, _styles.media.tablet(_templateObject9, sp.s), colors.grey);
	
	var RelatedWorkWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__RelatedWorkWrapper'
	})(['background-color:', ';padding-top:100px;'], colors.lightBlue);
	
	var RelatedWork = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__RelatedWork'
	})(['h2{font-size:48px;line-height:58px;font-weight:500;color:', ';text-align:center;}h3{margin-bottom:', ';font-size:24px;line-height:32px;font-weight:500;color:', ';text-align:center;}'], colors.navy, sp.xxl, colors.navy);
	
	var TestimonialWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'CaseStudyPage__TestimonialWrapper'
	})(['']);
	
	function CaseStudyPage(_ref) {
	  var data = _ref.data;
	  var heading = data.heading,
	      slug = data.slug,
	      excerpt = data.excerpt,
	      content = data.content,
	      contentAfter = data.contentAfter,
	      featureImages = data.featureImages,
	      headerBackgroundImage = data.headerBackgroundImage,
	      industry = data.industry,
	      services = data.services,
	      testimonial = data.testimonial,
	      relatedCaseStudies = data.relatedCaseStudies,
	      seoTitle = data.seoTitle,
	      seoKeywords = data.seoKeywords,
	      seoDescription = data.seoDescription;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: seoTitle,
	      keywords: seoKeywords,
	      description: seoDescription && seoDescription.seoDescription
	    }),
	    _react2.default.createElement(_components.Header, {
	      heading: heading,
	      excerpt: excerpt.excerpt,
	      slug: slug,
	      image: headerBackgroundImage
	    }),
	    _react2.default.createElement(
	      WorkMeta,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        { narrow: true },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Client:'
	          ),
	          ' ',
	          heading
	        ),
	        industry && _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Industry:'
	          ),
	          ' ',
	          industry
	        ),
	        services && _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Services:'
	          ),
	          ' ',
	          services.services
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        { narrow: true },
	        _react2.default.createElement(_reactMarkdown2.default, { source: content.content, escapeHtml: false })
	      )
	    ),
	    _react2.default.createElement(
	      FeatureImages,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          FeatureImagesWrapper,
	          null,
	          featureImages && featureImages.map(function (featureImage) {
	            return _react2.default.createElement(
	              FeatureImage,
	              { key: featureImage.id },
	              _react2.default.createElement('img', { src: featureImage.fullSize.src, alt: '' })
	            );
	          })
	        )
	      )
	    ),
	    contentAfter && _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        { narrow: true },
	        _react2.default.createElement(_reactMarkdown2.default, {
	          source: contentAfter.contentAfter,
	          escapeHtml: false
	        })
	      )
	    ),
	    _react2.default.createElement(
	      TestimonialWrapper,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        testimonial && _react2.default.createElement(_components.Testimonial, { testimonial: testimonial })
	      )
	    ),
	    _react2.default.createElement(
	      RelatedWorkWrapper,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        relatedCaseStudies && _react2.default.createElement(
	          RelatedWork,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'See how we\u2019ve done it for others.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Sell more by effectively marketing your business.'
	          ),
	          _react2.default.createElement(_shared.RelatedCaseStudies, { relatedCaseStudies: relatedCaseStudies })
	        )
	      )
	    )
	  );
	}
	
	CaseStudyPage.propTypes = {
	  data: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = CaseStudyPage;
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    height: 600px;\n  '], ['\n    height: 600px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      padding-top: ', ';\n      font-size: 40px;\n      line-height: 47px;\n    '], ['\n      padding-top: ', ';\n      font-size: 40px;\n      line-height: 47px;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      font-size: 48px;\n      line-height: 58px;\n    '], ['\n      font-size: 48px;\n      line-height: 58px;\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    padding-top: ', ';\n    padding-right: ', ';\n    width: 50%;\n  '], ['\n    padding-top: ', ';\n    padding-right: ', ';\n    width: 50%;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n  '], ['\n    width: 50%;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n      max-width: none;\n      bottom: -100px;\n  '], ['\n      max-width: none;\n      bottom: -100px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var CaseStudyBreadcrumbs = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Breadcrumbs).withConfig({
	  displayName: 'Header__CaseStudyBreadcrumbs'
	})(['']);
	
	var BannerContainer = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'Header__BannerContainer'
	})(['height:100%;', ';'], _styles.media.tablet(_templateObject));
	
	var StyledHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__StyledHeader'
	})(['background-color:', ';', ';h1{max-width:600px;padding-top:', ';font-size:30px;line-height:36px;color:', ';', ';', ';}'], _styles.theme.colors.white, _styles.media.tablet(_templateObject2), sp.xl, colors.navy, _styles.media.tablet(_templateObject3, sp.max), _styles.media.laptop(_templateObject4));
	
	var BannerContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__BannerContent'
	})(['padding-top:', ';position:relative;width:100%;', ';'], sp.l, _styles.media.tablet(_templateObject5, sp.max, sp.max));
	
	var BannerImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__BannerImage'
	})(['width:100%;', ';img{display:block;position:relative;max-width:100%;height:auto;margin:0 auto;bottom:-50px;', ';}'], _styles.media.tablet(_templateObject6), _styles.media.tablet(_templateObject7));
	
	function Header(_ref) {
	  var heading = _ref.heading,
	      image = _ref.image,
	      slug = _ref.slug,
	      excerpt = _ref.excerpt;
	
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: 'Work',
	    link: '/work'
	  }, {
	    name: heading,
	    link: '/work/' + slug
	  }];
	  return _react2.default.createElement(
	    StyledHeader,
	    null,
	    _react2.default.createElement(
	      BannerContainer,
	      null,
	      _react2.default.createElement(
	        BannerContent,
	        null,
	        _react2.default.createElement(CaseStudyBreadcrumbs, { breadcrumbs: breadcrumbs, left: true }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          excerpt
	        )
	      ),
	      _react2.default.createElement(
	        BannerImage,
	        null,
	        _react2.default.createElement('img', { src: image.responsiveResolution.src, alt: image.heading })
	      )
	    )
	  );
	}
	
	Header.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  excerpt: _propTypes2.default.string.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(401);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n    justify-content: space-between;\n    padding-top: 100px;\n    padding-bottom: 160px;\n  '], ['\n    display: flex;\n    justify-content: space-between;\n    padding-top: 100px;\n    padding-bottom: 160px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    bottom: auto;\n\n    ', '\n  '], ['\n    bottom: auto;\n\n    ', '\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 100px;\n    height: 100px;\n  '], ['\n    width: 100px;\n    height: 100px;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 36px;\n    line-height: 48px;\n  '], ['\n    font-size: 36px;\n    line-height: 48px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    font-size: 24px;\n    line-height: 36px;\n  '], ['\n    font-size: 24px;\n    line-height: 36px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _types = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _quotes = __webpack_require__(1510);
	
	var _quotes2 = _interopRequireDefault(_quotes);
	
	var _styles = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Wrapper'
	})(['padding-top:0;padding-bottom:40px;', ';'], _styles.media.tablet(_templateObject));
	
	var Quote = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Quote'
	})(['position:relative;bottom:-30px;padding-right:', ';', ';', ';'], _styles.theme.sp.m, function (props) {
	  return props.flip && '\n      display: none;\n    ';
	}, _styles.media.tablet(_templateObject2, function (props) {
	  return props.flip && '\n      display: block;\n      transform rotate(180deg);\n    ';
	}));
	
	var TestimonialWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__TestimonialWrapper'
	})(['position:relative;z-index:1;max-width:800px;']);
	
	var Image = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Image'
	})(['display:block;margin-left:', ';border-radius:50%;background-image:url(\'', '\');background-size:contain;background-position:50% 50%;background-repeat:no-repeat;width:60px;height:60px;', ';'], _styles.theme.sp.l, function (props) {
	  return props.imageUrl;
	}, _styles.media.tablet(_templateObject3));
	
	var TestimonialFooter = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__TestimonialFooter'
	})(['display:flex;justify-content:flex-end;']);
	
	var TestimonialMeta = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__TestimonialMeta'
	})(['display:flex;flex-direction:column;justify-content:center;']);
	
	// prettier-ignore
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Content'
	})(['font-size:24px;line-height:32px;font-weight:500;font-style:italic;margin-bottom:', ';color:', ';', ';'], _styles.theme.sp.max, _styles.theme.colors.royal, _styles.media.tablet(_templateObject4));
	
	// prettier-ignore
	var Name = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Name'
	})(['font-size:18px;line-height:24px;font-weight:500;color:', ';text-align:right;', ';'], _styles.theme.colors.navy, _styles.media.tablet(_templateObject5));
	
	// prettier-ignore
	var Position = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Testimonial__Position'
	})(['font-size:18px;line-height:24px;font-weight:500;color:', ';text-align:right;', ';'], _styles.theme.colors.grey, _styles.media.tablet(_templateObject5));
	
	var propTypes = {
	  testimonial: _types.TestimonialType.isRequired
	};
	
	function Testimonial(_ref) {
	  var testimonial = _ref.testimonial;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Quote,
	      null,
	      _react2.default.createElement('img', { src: _quotes2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      TestimonialWrapper,
	      null,
	      _react2.default.createElement(
	        Content,
	        null,
	        testimonial.testimonial.text
	      ),
	      _react2.default.createElement(
	        TestimonialFooter,
	        null,
	        _react2.default.createElement(
	          TestimonialMeta,
	          null,
	          _react2.default.createElement(
	            Name,
	            null,
	            testimonial.name
	          ),
	          _react2.default.createElement(
	            Position,
	            null,
	            testimonial.position
	          )
	        ),
	        testimonial.logo && _react2.default.createElement(Image, { imageUrl: testimonial.logo.fullSize.src })
	      )
	    ),
	    _react2.default.createElement(
	      Quote,
	      { flip: true },
	      _react2.default.createElement('img', { src: _quotes2.default, alt: '' })
	    )
	  );
	}
	
	Testimonial.propTypes = propTypes;
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Testimonial = __webpack_require__(403);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Testimonial2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Testimonial = exports.Header = undefined;
	
	var _Header = __webpack_require__(402);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Testimonial = __webpack_require__(404);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;
	exports.Testimonial = _Testimonial2.default;

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CaseStudyPage = __webpack_require__(400);
	
	var _CaseStudyPage2 = _interopRequireDefault(_CaseStudyPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _CaseStudyPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 1510:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9Ijc1IiB2aWV3Qm94PSIwIDAgMTAwIDc1IiB3aWR0aD0iMTAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im05NS44MTA2MzYxIDAgMi43OTI5MDkzIDYuNzE1NTg5NTRjLTE3Ljg3NjkyNzQgNS43ODM2Mzk2Ni0yNi44MTQyMzY5IDE0LjkyNzM4NjU2LTI2LjgxNDIzNjkgMjcuNDI2NjE1NjYgMCA3LjgzNDg1NDUgNC42OTk0NzM3IDExLjc1MjI4MTcgMTQuMTA1MzQ1NyAxMS43NTIyODE3IDkuMzk4OTQ3NSAwIDE0LjEwNTM0NTggNC44NTQwMDIyIDE0LjEwNTM0NTggMTQuNTUyNzU2NiAwIDkuNzAzMzc5My01LjY4MDQ1NDMgMTQuNTUyNzU2NS0xNy4wMzY3NDY0IDE0LjU1Mjc1NjUtOC4xOTg2ODg5IDAtMTQuNzE0NzA3OC0zLjE3MDQ3OTgtMTkuNTU0OTgxLTkuNTE2MDY0NC00LjI4NjMwNzktNS43ODEzMjcxLTYuNDIzNjkxMy0xMi44NzE1NDY2LTYuNDIzNjkxMy0yMS4yNjgzNDYxIDAtMjIuMDEwNjY4NCAxMi45Mzk3MTAxLTM2Ljc1MDczOTk3IDM4LjgyNjA1NDgtNDQuMjE1NTg5NW0tNTYuOTgyMjczMSAwIDIuNzkwNjAxMSA2LjcxNTU4OTU0Yy0xNy44NzY5Mjc0IDUuNzgzNjM5NjYtMjYuODE0MjM2OSAxNC45MjczODY1Ni0yNi44MTQyMzY5IDI3LjQyNjYxNTY2IDAgNy44MzQ4NTQ1IDQuNjk5NDczNyAxMS43NTIyODE3IDE0LjEwNzY1MzkgMTEuNzUyMjgxNyA5LjQwMTI1NTcgMCAxNC4xMDUzNDU4IDQuODU0MDAyMiAxNC4xMDUzNDU4IDE0LjU1Mjc1NjYgMCA5LjcwMzM3OTMtNS42ODI3NjI0IDE0LjU1Mjc1NjUtMTcuMDM5MDU0NiAxNC41NTI3NTY1LTguMTk4Njg4OSAwLTE0LjcxMjM5OTYtMy4xNzA0Nzk4LTE5LjU1NDk4MTA0LTkuNTE2MDY0NC00LjI4Mzk5OTYzLTUuNzgxMzI3MS02LjQyMzY5MTI2LTEyLjg3MTU0NjYtNi40MjM2OTEyNi0yMS4yNjgzNDYxIDAtMjIuMDEwNjY4NCAxMi45NDIwMTgzLTM2Ljc1MDczOTk3IDM4LjgyODM2My00NC4yMTU1ODk1IiBmaWxsPSIjZmZkOTNiIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CaseStudyPage = __webpack_require__(406);
	
	var _CaseStudyPage2 = _interopRequireDefault(_CaseStudyPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseStudy(_ref) {
	  var pathContext = _ref.pathContext;
	
	  return _react2.default.createElement(_CaseStudyPage2.default, { data: pathContext });
	}
	
	CaseStudy.propTypes = {
	  pathContext: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = CaseStudy;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-case-study-js-67bda79e2afcbed7d6bd.js